module.exports = __webpack_public_path__ + "static/media/object_desk.1d261deb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/NosProjets/object_desk.png
// module id = 2253
// module chunks = 0